<template>
  <div>
    <loading-container v-if="loading"></loading-container>

    <div v-else class="container">
      <div class="row">
        <div class="col-xs-6">
          <help-text>
            <h3>
              Create Mailing List
            </h3>

            <p>
              Enter the details of the mailing list.
            </p>
          </help-text>
        </div>

        <div class="col-xs-18">
          <div class="panel panel-default">
            <div class="panel-body">
              <form @submit.prevent="submit" class="form-horizontal">
                <SelectFormGroup
                    v-model="data.reference"
                    name="reference"
                    label="Reference"
                    help-text="The reference to the mailing list."
                    :error="getError('reference')"
                    :options="externalMailingListOptions"
                />

                <hr>

                <SubmitFormGroup button-class="btn-black"/>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import HelpText from '@/components/HelpText'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'

export default {
  components: {HelpText, LoadingContainer, SelectFormGroup, SubmitFormGroup},

  mixins: [Errors],

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      data: {},
      externalMailingLists: null,

      loading: true
    }
  },

  mounted() {
    http.get('/api/v2/external/mailing-lists').then(response => {
      this.externalMailingLists = response.data.data

      this.loading = false
    })
  },

  computed: {
    externalMailingListOptions() {
      return this.externalMailingLists.map(externalMailingList => {
        return {
          value: externalMailingList.id,
          label: externalMailingList.attributes.name
        }
      })
    }
  },

  methods: {
    submit() {
      http.post('/api/v2/mailing-lists', {...this.data, portal_id: this.portal.id})
          .then(() => {
            notify.success('The mailing list was saved')

            this.$router.push('/portals/' + this.portal.id + '/mailing-lists')
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
